import React, { useState, useEffect, useCallback, useReducer } from 'react';
import {
	Card,
	useAjax,
    XhrStatus,
	formUpdateFieldValues,
    InputField
} from '@bosch/bt-ui';

import './SimManagementPage.css';
import SimDeactivatePage from './SimDeactivatePage';
import QueryVPNInfoPage from './QueryVPNInfoPage';
import SimMarkUnusablePage from './SimMarkUnusablePage';
import SimBatchDeactivatePage from './SimBatchDeactivatePage';
import withErrorHandler from '../../components/ErrorHandler';
import RestfulCallout from '../../components/RestfulCallout';
import RestfulCallLoading from '../../components/RestfulCallLoading';

const SimManagementPage = (props) => {
	const {
		token,
	} = props;
	const [subTask, setSubTask] = useState(null);
	const [formValues, updateFormValues] = useReducer(formUpdateFieldValues, "");
	const [returnResult, status, runAjax, response] = useAjax(XhrStatus.Initial);
	const [returnObj, setReturnObj] = useState(null);
	const [ajaxStatus, setAjaxStatus] = useState(XhrStatus.Initial);

	useEffect(() => {
		console.log('SimManagementPage==========>')
		console.log(response)
		console.log(returnResult)
		console.log(token)

		setAjaxStatus(status);
		setReturnObj(returnResult);
    }, [status]);

	useEffect(() => {
		setAjaxStatus(XhrStatus.Initial);
		setReturnObj(null);
    }, [formValues]);

	return (
		<Card
			background="secondary"
			htmlAttributes={{
				className: 'sim-management-page'
			}}
		>
			<RestfulCallout status={ajaxStatus} response={response} returnObj={returnObj} />
			<div id="sim-management">
				<div className="sim-input">
					<div className="font-large">SIM:</div>
					<div className="sim-input-field">
						<InputField
							inputType="text"
							fieldName="SimId"
							htmlAttributes={{
								onChange: updateFormValues,
								value: formValues.SimId
							}}
						/>
					</div>
				</div>
				<div className="sim-operation-left">
					<QueryVPNInfoPage subTask={subTask} setSubTask={setSubTask} token={token} formValues={formValues} runAjax={runAjax} returnObj={returnObj} />
					<SimDeactivatePage subTask={subTask} setSubTask={setSubTask} token={token} formValues={formValues} runAjax={runAjax} />
				</div>
				<div className="sim-operation-right">
					<SimMarkUnusablePage subTask={subTask} setSubTask={setSubTask} token={token} formValues={formValues} runAjax={runAjax} returnObj={returnObj} />
					<SimBatchDeactivatePage token={token} />
				</div>
			</div>
			<RestfulCallLoading status={ajaxStatus} />
		</Card>
	);
};

export default withErrorHandler(React.memo(SimManagementPage));